var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        [
          _vm.getFormConfig
            ? _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.clearPLabel(_vm.getFormConfig.label)),
                  },
                }),
              ])
            : _vm._e(),
          _vm.getFormConfig && _vm.getFormConfig.notice
            ? _c("el-alert", {
                staticStyle: { "margin-bottom": "10px" },
                attrs: {
                  title: _vm.getFormConfig.notice.content,
                  "show-icon": "",
                  type: "warning",
                },
              })
            : _vm._e(),
          _c("avue-form", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.isLoading,
                expression: "isLoading",
              },
            ],
            attrs: { option: _vm.planOption },
            on: { submit: _vm.onSubmitPlan },
            scopedSlots: _vm._u([
              {
                key: "menuForm",
                fn: function (ref) {
                  return [
                    !_vm.planOption.submitBtn && !_vm.isAdd
                      ? _c(
                          "el-button",
                          {
                            attrs: { icon: "el-icon-edit" },
                            on: {
                              click: function ($event) {
                                return _vm.onCheckPlanResult(false)
                              },
                            },
                          },
                          [_vm._v("\n\t\t\t\t\t修改\n\t\t\t\t")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.planFormData,
              callback: function ($$v) {
                _vm.planFormData = $$v
              },
              expression: "planFormData",
            },
          }),
        ],
        1
      ),
      _c("InsureNotices", {
        ref: "refInsureNotices",
        on: { onToCancel: _vm.onToCancel, onToInsure: _vm.onGoInsure },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }